import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import "../css/KeyStrengthsPage.css";

const KeyStrengthsPage = () => {
  // Data for the three text blocks
  const strengthBlocks = [
    {
      id: 1,
      items: [
        "Strategic Location; Lying at the hub of shipping lanes joining East and West",
        "Over 50 years experience in Ship Repairs, Shipbuilding and Heavy Engineering Sectors",
        "Workforce of over 3,000 Sri Lankans",
        "Operators 4 drydocks up to 125,000 dwt",
        "Certified to ISO 9001:2015 International Standards for Quality Management Systems in 2017",
      ],
    },
    {
      id: 2,
      items: [
        "<strong>Ship Repairs</strong> : 200 vessels per annum generating over US$45 million",
        "<strong>Shipbuilding</strong> : 2 highly specialized and complex vessels with an annual turnover of over USD 100 million",
        "<strong>Heavy Engineering</strong>: Heavy steel fabrication over US$ 10 million per annum",
      ],
    },
    {
      id: 3,
      items: [
        // "Average annual turnover over US$ 150 million",
        "State of the art Machinery and Equipment",
        "Heavy lifting capability up to 160 tons",
        "500 ton Steel Press",
        "CNC Plasma Cutting Machines",
        "Combined blasting and painting workshops with controlled conditions for application of specialized protective coatings",
      ],
    },
  ];

  // Flatten items to assign sequential delays
  const allItems = strengthBlocks.flatMap((block) => block.items);
  // We'll use index in map to get delay

  return (
    <>
      <Header />

      <div className="keystrengths-wrapper">
        <div className="center-container">
          {/* Breadcrumb */}
          <div className="breadcrumbs">
            <Link to="/">Home</Link> &gt; <span>Key Strengths</span>
          </div>

          <h1 className="page-title" data-aos="fade-right">Key Strengths</h1>

          {/* Full‑width background section – without dark overlay */}
          <div
            className="keystrengths-bg-row"
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL}/wp-content/uploads/2016/03/Key-Strength-Background.JPG)`,
            }}
          >
            {/* No overlay div – removed */}
            <div className="keystrengths-content">
              <div className="keystrengths-column">
                {strengthBlocks.map((block, index) => (
                  <div
                    key={block.id}
                    className="strength-box"
                    data-aos="fade-up"
                    data-aos-delay={index * 100}
                  >
                    {block.items.map((item, idx) => (
                      <React.Fragment key={idx}>
                        <p dangerouslySetInnerHTML={{ __html: item }} data-aos="fade-up" />
                        {idx < block.items.length - 1 && <hr />}
                      </React.Fragment>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <BackToTop />
    </>
  );
};

export default KeyStrengthsPage;
